module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/bg2-f367f64eab431badf75836db107963de.jpg";